import HttpService from "./htttp.service";

class UnitsService {
  getUnits = async (query, cancelToken) => {
    const endpoint = "units";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createUnit = async (payload) => {
    const endpoint = "units";
    return await HttpService.post(endpoint, payload);
  };

  removeUnit = async (id) => {
    const endpoint = "units/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateUnit = async (id, payload) => {
    const endpoint = "units/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new UnitsService();
